module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av39-e471b23e086756d79b0b88a70315a27e.jpg";